export const GA_MEASUREMENT_ID = 'G-F3QXGEJMTL';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let installed = false;

export function shouldLoadAnalytics(hostname: string): boolean {
  return hostname === 'sourcetape.io' || hostname === 'www.sourcetape.io';
}

export function installGtag(): void {
  if (installed) return;
  if (typeof window === 'undefined') return;
  if (!shouldLoadAnalytics(window.location.hostname)) return;
  installed = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackPageview(path: string): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
  });
}
